import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { LocationGroupRepository } from '../../repositories/location-group.repository';
import { EditLocationGroup } from '../../domain/requests/location-group/edit-location-group-request';
import { BaseResponse } from 'planning-portal-library/src/lib/data/shared/base.response';

@Injectable({ providedIn: 'root' })
export class EditLocationGroupUsecase implements UseCase<EditLocationGroup, BaseResponse<boolean>> {
  constructor(private readonly locationGroupRepository: LocationGroupRepository) {}

  execute(params: EditLocationGroup): Observable<BaseResponse<boolean>> {
    return this.locationGroupRepository.EditLocationGroup(params);
  }
}
